export default "__VITE_ASSET__Dk5E2B_x__"